import { fetchDetails } from '@/modules/check-in/service/fetchDetails'
import { fetchTags } from '@/modules/check-in/service/fetchTags'

export const CHECK_IN_MODULE = 'CHECK_IN'

export default {
  state: {
    list: {},
    tags: {
      list: [],
      alreadyLoaded: false
    },
    showDetailId: null
  },
  actions: {
    async fetchDetail ({ state, commit, dispatch }, { id }) {
      await dispatch('loadTagsList')
      const response = await fetchDetails(id)

      // Tags atribuídas ao participante: vêm sempre completas (sem filtro de
      // escopo do operador) — assim o operador vê o contexto inteiro, mesmo
      // que ele só possa setar/remover as tags do allowed_tag_ids dele.
      // Cada tag é marcada como editable=true só se está no escopo do operador.
      const allowedIds = new Set((state.tags.list || []).map(t => t.id))
      const assignedTags = (response.tags || []).map(tag => ({
        ...tag,
        isChecked: true,
        isEditable: allowedIds.has(tag.id)
      }))

      // Tags do escopo que o participante NÃO tem (pra admin poder adicionar
      // via toggle). Operadores não conseguem clicar nessas (gate é por permissão).
      const assignedIds = new Set(assignedTags.map(t => t.id))
      const addableTags = (state.tags.list || [])
        .filter(t => !assignedIds.has(t.id))
        .map(t => ({ ...t, isChecked: false, isEditable: true }))

      commit('setItem', {
        id: response.id,
        isStatusCheckIn: response.isStatusCheckIn,
        isStatusCheckOut: response.isStatusCheckOut,
        isStatusUnseen: !response.isStatusCheckIn && !response.isStatusCheckOut,
        name: response.name,
        email: response.email,
        badge_name: response.badge_name,
        school: response.school,
        codId: response.codId,
        grupo: response.grupo,
        tags: [...assignedTags, ...addableTags],
        historico: response.historico,
        activitiesList: response.activitiesList,
        commentsList: response.commentsList
      })
    },
    async loadTagsList ({ state, commit }) {
      if (state.tags.alreadyLoaded) {
        return
      }
      const tags = await fetchTags()
      commit('updateTags', { tags })
    }
  },
  getters: {
    detailById: state => id => {
      return state.list[id] ?? undefined
    }
  },
  mutations: {
    setItem (state, {
      id,
      isStatusCheckIn,
      isStatusCheckOut,
      isStatusUnseen,
      name,
      email,
      // eslint-disable-next-line camelcase
      badge_name,
      school,
      codId,
      grupo,
      tags,
      historico,
      activitiesList,
      commentsList
    }) {
      const item = {
        id,
        isStatusCheckIn,
        isStatusCheckOut,
        isStatusUnseen,
        name,
        email,
        badge_name,
        school,
        codId,
        grupo,
        tags,
        historico,
        activitiesList,
        commentsList
      }
      state.list = { ...state.list, [id]: item }
    },
    updateTags (state, { tags }) {
      state.tags.alreadyLoaded = true
      state.tags.list.push(...tags)
    },
    updateItemStatus (state, { id, isStatusCheckIn, isStatusCheckOut, isStatusUnseen, userLoggedInName = '', details = '' }) {
      const item = state.list[id]
      if (!item) {
        return
      }
      item.isStatusCheckIn = isStatusCheckIn
      item.isStatusCheckOut = isStatusCheckOut
      item.isStatusUnseen = isStatusUnseen
      if (!item.isStatusUnseen) {
        item.activitiesList.unshift({
          at: new Date(),
          by: userLoggedInName,
          isManual: false,
          isStatusCheckIn: isStatusCheckIn,
          details
        })
      }
    },
    setShowDetailId (state, id) {
      state.showDetailId = id
    }
  },
  namespaced: true
}
